
import Datetime from 'vux/src/components/datetime/index.vue'


export default {
name: 'addVisit',
components: {
Datetime
},
data () {
return {
formData:{
id:0,
cid:0,
labels:'',
content:'',
visit_time:'',
},
title:'',
labels:[],
datetimeStatus:false,
startDate:'',
endDate:'',
minHour:6,
maxHour:24,
days:7,
}
},
created(){
this.formData.cid = Number(this.$route.params.cid);
this.formData.id = Number(this.$route.params.id);
this.title = this.$route.params.title;
this.setDate();
this.visitLabels();
},
mounted(){
if(this.formData.id > 0){
this.getInfo();
}
},
activated(){

},
methods:{
setDate() {
var nowDate = new Date();
var date = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate() - 7,
hour: nowDate.getHours(),
}
this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
this.minHour = date.hour+1;
if(nowDate.getHours() >= this.maxHour-1){
var date = new Date(this.startDate);
date.setDate(date.getDate() + 1);
var date1 = {
year: date.getFullYear(),
month: date.getMonth() + 1,
day: date.getDate(),
}
this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
}
var date = new Date(this.startDate);
date.setDate(date.getDate() + this.days);
var date1 = {
year: date.getFullYear(),
month: date.getMonth() + 1,
day: date.getDate(),
}
this.endDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
if(!this.formData.id){
this.formData.visit_time = this.endDate;
}
},
datetimeChange(val){
this.formData.visit_time = val;
this.datetimeStatus = false;
},
addLabel(title){
if(title){
this.formData.labels += '#'+title;
}else{
this.formData.labels += '#';
}
this.$refs.textarea.focus();
},
getInfo(){
this.$api.visit({id:this.formData.id}).then((res)=>{
if(res){
this.formData = res.data[0];
}
})
},
visitLabels(){
this.$api.visitLabels({}).then((res)=>{
if(res){
this.labels = res.data;
}
})
},
submit(){
if(!this.formData.cid){
this.$func.showToast('社区id不存在');
return false;
}
if(!this.formData.labels){
this.$func.showToast('请添加拜访标签');
return false;
}
if(!this.formData.visit_time){
this.$func.showToast('请选择拜访时间');
return false;
}
this.$api.submitVisit(this.formData).then((res)=>{
if(res){
this.$func.showToast('提交成功');
setTimeout(()=>{
this.$router.go(-1);

},1000)
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/addVisit.vue